import { string } from 'prop-types';
import React from 'react';

import css from './NetworkQualityWarning.less';

function NetworkQualityWarning({ name }) {
  return <div className={css.container}>{name} internet connection is unstable</div>;
}

NetworkQualityWarning.defaultProps = {
  name: 'Your',
};

NetworkQualityWarning.propTypes = {
  name: string,
};

export default NetworkQualityWarning;
